import { setItem, getItem } from "@/utils/storage";
import * as types from "@/common/vuex.const";

let lifeData = {};
try {
  // 尝试获取本地是否存在lifeData变量，第一次启动APP时是不存在的
  lifeData = getItem(types.LIFE_DATA);
  lifeData = lifeData ? lifeData : {};
} catch (e) {}

const saveLifeData = function(key, value) {
  // 判断变量名是否在需要存储的数组中
  // 获取本地存储的lifeData对象，将变量添加到对象中
  let tmp = getItem(types.LIFE_DATA);
  // 第一次打开APP，不存在lifeData变量，故放一个{}空对象
  tmp = tmp ? tmp : {};
  tmp[key] = value;
  // 执行这一步后，所有需要存储的变量，都挂载在本地的lifeData对象中
  setItem(types.LIFE_DATA, tmp);
};

export default {
  namespaced: true,
  state: {
    vuex_user: lifeData[types.USER_KEY] ? lifeData[types.USER_KEY] : {},
    vuex_token: lifeData[types.TOKEN_KEY] ? lifeData[types.TOKEN_KEY] : ""
  },
  mutations: {
    [types.UPDATE_TOKEN]: (state, token) => {
      state.vuex_token = token;
      saveLifeData(types.TOKEN_KEY, token);
    },
    [types.UPDATE_USER]: (state, user) => {
      state.vuex_user = user;
      saveLifeData(types.USER_KEY, user);
    }
  }
};
